<template>
  <div class="modal">
    <div class="modal__box">
      <div class="modal__header">
        <img src="@/assets/img/ic-navi-cancle.svg" @click="$emit('close')" />
      </div>
      <div class="modal__body">
        <div v-html="msg" class="message"></div>
        <button @click="$emit('close'), $emit('confirm')">확인</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["msg"],
};
</script>
<style scoped>
.modal {
  position: fixed;
  z-index: 9999999;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.64);
  transition: opacity 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal__box {
  position: absolute;
  box-sizing: border-box;
  background-color: var(--white);
  box-shadow: 0px 8px 16px -4px rgba(63, 83, 107, 0.08);
  box-sizing: border-box;
  border-radius: 16px;
  padding: 20px;
  margin: 0px 20px;
}

.modal__header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}

.modal__header img {
  cursor: pointer;
}
.modal__body {
  width: 385px;
  box-sizing: border-box;
  padding: 0px 20px 12px 20px;
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.message {
  color: var(--gray-700);
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
  word-wrap: break-word;
  word-break: keep-all;
}

button {
  background-color: var(--white);
  width: 100%;
  height: 56px;
  box-sizing: border-box;
  color: var(--gray-600);
  border: 1px solid var(--gray-300);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
}

button:hover {
  background-color: var(--gray-100);
}

@media all and (max-width: 1023px) {
  .modal__box {
    max-width: 360px;
    width: 90%;
  }

  .modal__body {
    width: 100%;
  }
}
</style>
